export { RecaptchaBadge } from './RecaptchaBadge';
export type { RecaptchaBadgeProps } from './RecaptchaBadge';
